const generateIframeTag = (src: string): HTMLIFrameElement => {
  const iframe = document.createElement("iframe");
  iframe.src = src;

  return iframe;
};

const loadIframes = (iframeUrls: string[], callback: () => void): void => {
  const loadedIframe = [];
  iframeUrls.forEach((src: string) => {
    const iframe = generateIframeTag(src);
    const iframeContainer = document.getElementById("iframe-container");

    if (iframeContainer) {
      iframeContainer.append(iframe);
    }

    iframe.onload = () => {
      loadedIframe.push(src);
      iframe.remove();

      if (loadedIframe.length === iframeUrls.length) {
        callback();
      }
    };
  });
};

export const fetchContents = (contents: string[]): any =>
  Promise.allSettled(contents.map((content: string) => fetch(content)));

export const saveContentToCache = (
  content: any,
  iframeUrls: string[],
  callback: () => void,
): void => {
  const checkLast = (i: number): void => {
    if (content.length === i + 1) {
      if (iframeUrls.length > 0) {
        loadIframes(iframeUrls, callback);
      } else {
        callback();
      }
    }
  };

  caches.open("assignments-content").then((cache) => {
    content.forEach(({ status, value }: any, index: number) => {
      if (status === "fulfilled") {
        const url = new URL(value.url);
        const response = value.clone();
        value.blob().then(() => {
          cache.put(`${url.origin}${url.pathname}`, response).then(() => {
            checkLast(index);
          });
        });
      } else {
        checkLast(index);
      }
    });
  });
};
